import { Component } from '@angular/core';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-payment-detail-s02-p020',
  templateUrl: './payment-detail-s02-p020.component.html',
})
export class PaymentDetailS02P020Component extends SupportComponent {
  constructor(private _common: CommonLibService) {
    super(_common);
  }

  override init(): void {
    /* override abstract init function of base class */
  }

  override reload(): void {
    /* override abstract reload function of base class */
  }

  override destroy(): void {
    /* override abstract destroy function of base class */
  }
}
